<template>
    <PullContainer
        ref="pullContainerRef"
        :pullDownLoading="true"
        :pullDownLabel="true"
        @pullDownLoadingSuccess="pullDownLoadingSuccess"
    >
        <template #container>
            <div class="public_container mobile_approval_wrap" ref="mobile_approval_wrap" v-loading="loading">
                <van-sticky :container="'mobile_approval_wrap'">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

                        </ReturnNavBar>
                    </div>
                </van-sticky>
                <div class="mobile_container">
                    <ul class="top_tab_wrap">
                        <li v-for="tab in approval_tab_list"  :key="tab.state" :class="{ active: approval_tab_state == tab.state }"  @click="handleClickTabState(tab)">
                            <span>
                                <i :class="['iconfont', approval_tab_state == tab.state ? tab.activeIcon : tab.icon]"></i>
                            </span>
                            <span>{{ tab.name }}{{tab.state === 'awaiting_my_action' ? `(${approvalPendingNum > 99 ? '99+' : approvalPendingNum})` : ''}}</span>
                        </li>
                    </ul>
                    <div class="card_list_wrap card_list_wrap1 mt_10">
                        <p class="card_list_wrap_title">常用审批</p>
                        <div class="menu_container">
                            <van-swipe @change="onChangeSwipe" :show-indicators="false">
                                <template v-if="commonApprovalList.length">
                                    <van-swipe-item v-for="(swiperItem, swiperIndex) in commonApprovalSplitList">
                                        <ul>
                                            <li
                                                class="list_item"
                                                :class="['list_item', { list_item_add: item.type === 'add' }]"
                                                v-for="item in swiperItem"
                                                :key="item.id"
                                                @touchstart="onTouchStart(item, $event)"
                                                @touchmove="onTouchMove($event)"
                                                @touchend="onTouchEnd"
                                                @click="handleClickAddApproval(item)">
                                                <div class="list_item_icon_wrap">
                                                    <i class="iconfont icon-tianjia1" v-if="item.type === 'add'"  @click="handleClickAddOperate"></i>
                                                    <template v-else>
                                                        <img :src="item.approval_set && item.approval_set.icon ? item.approval_set.icon : defaultIcon" alt=""/>
                                                    </template>
                                                    <div class="list_item_more_icon" v-if="item.isOperateStatus && item.type !== 'add'">
                                                        <i class="iconfont icon-jianqu"  @click="handleClickDel(item.approval_set && item.approval_set.id)"></i>
                                                    </div>
                                                </div>
                                                <span>{{ item.approval_set && item.approval_set.name }}</span>
                                            </li>
                                        </ul>
                                    </van-swipe-item>
                                </template>
                            </van-swipe>
                        </div>
                        <div class="menu_carousel_wrap">
                            <span v-for="(carousel, carouselIndex) in commonApprovalSplitList.length" :class="{ active: carouselActiveIndex == carouselIndex }"></span>
                        </div>
                    </div>
                    <div class="all_menu_wrap mt_10" ref="container">
                        <van-sticky :container="'container'">
                            <div class="all_menu_list">
                                <ul>
                                    <li v-for="(category, categoryIndex) in allApprovalCategoryList"
                                        :key="category.id"
                                        :class="{ active: allApprovalCategoryActiveIndex == categoryIndex }"
                                        @click="handleClickAnchor('cardListItem' + categoryIndex, categoryIndex)">
                                        <span>{{ category.name }}</span>
                                    </li>
                                </ul>
                                <div class="all_menu_filter_icon" @click="handleClickCategoryPickerShow">
                                    <img src="https://download.hecoos.com/enlightv/2024-51/4c642c0c14402f868ad37bc896bb25fb.png" alt=""/>
                                </div>
                            </div>
                        </van-sticky>

                        <div class="all_menu_container" ref="allMenuContainer">
                            <div
                                class="card_list_wrap card_list_wrap2"
                                v-for="(category, categoryIndex) in allApprovalCategoryList"
                                :key="category.id"
                                :ref="'cardListItem' + categoryIndex">
                                <p class="card_list_wrap_title">{{ category.name }}</p>
                                <ul>
                                    <li
                                        class="list_item"
                                        v-for="(item, index) in category.approvals"
                                        :key="index"
                                        @touchstart="onTouchStart(item, $event)"
                                        @touchmove="onTouchMove($event)"
                                        @touchend="onTouchEnd"
                                        @click="handleClickAddApproval(item)">
                                        <div class="list_item_icon_wrap">
                                            <img :src="item.icon ? item.icon : defaultIcon" alt="" />
                                            <div  class="list_item_more_icon" v-if="item.isOperateStatus || isAllMoreOperate">
                                                <i class="iconfont icon-jianqu"  v-if="item.is_common" @click="handleClickDel(item)"></i>
                                                <i class="iconfont icon-tianjia_daidise1" @click="handleClickAdd(item)" v-else></i>
                                            </div>
                                        </div>
                                        <span>{{ item.name }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
            </div>
            <!-- 审批分类选择 -->
            <van-overlay
                :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                class-name="custom_more_overlay"
                v-if="showCategoryPicker"
                :show="showCategoryPicker"
                @click="showCategoryPicker = false"
            >
                <div class="radio_option_wrap">
                    <div class="radio_option_item" @click="handleClickCategoryPickerClose">
                        <span>审批分类</span>
                        <van-icon name="arrow-up" />
                    </div>
                    <ul class="radio_option_list">
                        <li
                            class="radio_option_item"
                            v-for="(category, categoryIndex) in allApprovalCategoryList"
                            :key="categoryIndex"
                            @click="handleClickAnchor('cardListItem' + categoryIndex, categoryIndex)"
                        >
                            <span>{{ category.name }}</span>
                            <van-icon name="success" v-if="allApprovalCategoryActiveIndex == categoryIndex" />
                        </li>
                    </ul>
                </div>
            </van-overlay>
        </template>
    </PullContainer>
</template>
<script>
import { commonList, approvalList, createCommon, ApprovalPendingNum } from "@/api";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import {mapState} from "vuex";
export default {
    name: "mobileApproval",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
    },
    data() {
        return {
            defaultIcon: "https://download.hecoos.com/enlightv/2024-51/9152c5313c0a4208c4b60b388a8e0723.png",
            loading: false,
            approval_tab_state: "",
            approval_tab_list: [
                {
                    state: "awaiting_my_action",
                    name: "待处理",
                    icon: "icon-shenpidaichuli",
                    activeIcon: "icon-shenpidaichuli_xuanzhong",
                    total: "0",
                    isPackUp: false,
                    children: [],
                },
                {
                    state: "already_handled_by_me",
                    name: "已处理",
                    icon: "icon-shenpiyichuli",
                    activeIcon: "icon-shenpiyichuli_xuanzhong",
                    total: "0",
                    isPackUp: false,
                    children: [],
                },
                {
                    state: "received_by_me",
                    name: "我收到",
                    icon: "icon-shenpiwoshoudao",
                    activeIcon: "icon-shenpiwoshoudao_xuanzhong",
                    total: "0",
                    isPackUp: false,
                },
                {
                    state: "initiated_by_me",
                    name: "我发起",
                    icon: "icon-a-wofaqi2-01",
                    activeIcon: "icon-shenpiwoshoudao_xuanzhong",
                    total: "0",
                    isPackUp: false,
                    children: [],
                },
            ],
            approvalPendingNum: 0,
            commonApprovalList: [], // 所有的常用功能
            commonApprovalSplitList: [], // 将数组拆开用来左右滑动
            carouselActiveIndex: 0,
            isAllMoreOperate: false, // 全部功能的按钮是否显示
            common_approval_ids: [], // 常用功能id
            // 全部审批分类
            allApprovalCategoryActiveIndex: 0,
            allApprovalCategoryList: [],
            tabBarActive: 0,
            tabBarList: [
                {
                    icon: "icon-faqishenpi",
                    activeIcon: "icon-faqishenpi1",
                    routerName: "mobileApproval",
                    title: "发起审批",
                },
                {
                    icon: "icon-shenpi_weixuanzhong",
                    activeIcon: "icon-shenpi_xuanzhong",
                    routerName: "mobileApprovalCenter",
                    title: "审批中心",
                },
            ],
            // 长按事件
            toucheX: 0,
            toucheY: 0,
            timeOutEvent: "",
            // 选择审批分类
            showCategoryPicker: false,
        };
    },
    created() {
        this.getApprovalPendingNum()
        this.getCommonApprovalData();
    },
    computed: {
        ...mapState(['tagList'])
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.getApprovalPendingNum();
                this.getCommonApprovalData('pull');
            }
        },
        // 跳转到新增审批
        handleClickAddApproval(item){
            let index = this.tagList.findIndex(find => find.name == 'mobileApproveAdd')
            this.$router.push({
                name: 'mobileApproveAdd',
                query:{
                    id:item.approval_set_id ? item.approval_set_id :item.id,
                    name:item.name ? item.name : item.approval_set.name,
                    type:item.type
                },
                params: {
                    isPush: index > -1 ? false  : true
                }
            })
        },
        // 将数组拆开
        chunkArray(array, chunkSize) {
            let result = [];
            for (let i = 0; i < array.length; i += chunkSize) {
                result.push(array.slice(i, i + chunkSize));
            }
            return result;
        },
        // 左右滑动切换
        onChangeSwipe(index) {
            this.carouselActiveIndex = index;
        },
        // 状态切换
        handleClickTabState(tab) {
            // this.approval_tab_state = tab.state;
            this.$router.push({
                name: "mobileApprovalCenter",
                query: {
                    processState: tab.state
                }
            })
        },
        // 滚动到指定的元素
        handleClickAnchor(ref, index) {
            this.allApprovalCategoryActiveIndex = index;
            const targetElement = this.$refs[ref];
            if (targetElement && targetElement.length) {
                targetElement[0].scrollIntoView({ behavior: "smooth" });
            }
            this.showCategoryPicker = false;
        },
        // 长按弹出上拉操作面板
        onTouchStart(item, e) {
            this.toucheX = e.targetTouches[0].screenX;
            this.toucheY = e.targetTouches[0].screenY;
            // 开启定时器前先清除定时器，防止重复触发
            this.timeOutEvent && clearTimeout(this.timeOutEvent); // 显示上拉面板
            this.timeOutEvent = setTimeout(() => {
                this.$set(item, "isOperateStatus", true);
            }, 500);
            // e.preventDefault(); // 阻止系统默认事件
        },
        onTouchMove(e) {
            const moveX = e.targetTouches[0].screenX;
            const moveY = e.targetTouches[0].screenY;
            // 解决vivo机型，手指没有move，touchmove事件仍然会调用而导致setTimeout被clear
            if (this.toucheX !== moveX || this.toucheY !== moveY) {
                // 手指滑动，清除定时器，中断长按逻辑
                this.timeOutEvent && clearTimeout(this.timeOutEvent);
            }
        },
        onTouchEnd() {
            // 清除定时器，结束长按逻辑
            this.timeOutEvent && clearTimeout(this.timeOutEvent); // 若手指离开屏幕，时间小于我们设置的长按时间，则为点击事件
        },
        // 添加操作
        handleClickAddOperate() {
            this.isAllMoreOperate = true;
        },
        // 添加常用功能
        handleClickAdd(item) {
            if (this.common_approval_ids.length == 8) {
                return this.$toast("最多添加8个常用审批，如需添加请先移除后再操作");
            }
            this.common_approval_ids.push(item.id);
            this.handleClickConfirm();
        },
        // 删除常用功能
        handleClickDel(item) {
            const key = this.common_approval_ids.findIndex((id) => item.id == id);
            this.common_approval_ids.splice(key, 1);
            this.handleClickConfirm();
        },

        // 显示审批分类弹框
        handleClickCategoryPickerShow() {
            this.showCategoryPicker = true;
        },
        handleClickCategoryPickerClose() {
            this.showCategoryPicker = false;
        },
        // 添加和删除常用功能提交
        handleClickConfirm() {
            createCommon({ common_data: this.common_approval_ids }).then((res) => {
                if (res.code === 200) {
                    this.$toast({
                        message: "操作成功",
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.getCommonApprovalData();
                        },
                    });
                    this.isAllMoreOperate = false;
                } else {
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
            });
        },
        // 获取待处理数量
        getApprovalPendingNum() {
            ApprovalPendingNum().then(res=> {
                if(res.code === 200) {
                    const data = res.data
                    this.approvalPendingNum = data.num || 0
                }
            })
        },
        // 获取常用审批
        getCommonApprovalData(type) {
            this.loading = true;
            commonList()
                .then((res) => {
                    if (res.code === 200) {
                        let data = res.data || [];
                        this.common_approval_ids = data.map((item) => item.approval_set && item.approval_set.id);
                        if (data.length < 8) {
                            data.push({ id: "", type: "add", approval_set: { name: "添加更多" } });
                        }
                        this.commonApprovalList = data;
                        this.commonApprovalSplitList = this.chunkArray(this.commonApprovalList, 4);
                        this.getApprovalData();
                    } else {
                        this.loading = flase;
                    }
                    if(type == 'pull'){
                        this.$refs.pullContainerRef.pullDownLoadingEnd('刷新成功');
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取所有审批
        getApprovalData() {
            this.loading = true;
            approvalList({ keyword: "" })
                .then((res) => {
                    if (res.code === 200) {
                        this.allApprovalCategoryList = res.data || [];
                        this.loading = false;
                    } else {
                        this.loading = flase;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_approval_wrap {
    .top_tab_wrap {
        height: 72px;
        background-color: #ffffff;
        display: flex;
        li {
            flex: 1;
            padding-top: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            span:nth-child(1) {
                width: 30px;
                height: 30px;
            }
            .iconfont {
                font-size: 30px;
                color: rgba(102, 102, 102, 1);
            }
            span:nth-child(2) {
                margin-top: 6px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(102, 102, 102, 1);
            }
            &.active,
            &:active {
                .iconfont,
                span:nth-child(2) {
                    color: rgba(41, 144, 255, 1);
                }
            }
        }
    }
    .mt_10 {
        margin-top: 10px;
    }
    .card_list_wrap {
        background-color: #ffffff;
        .card_list_wrap_title {
            padding: 10px 16px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
        }
        .menu_container {
            // overflow: hidden;
            // white-space: nowrap;
        }
        ul {
            transition: transform 0.3s;
            display: flex;
            .list_item {
                flex-shrink: 0;
                width: 25%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .list_item_icon_wrap {
                    position: relative;
                    width: 32px;
                    height: 32px;
                    img {
                        width: 32px;
                        height: 32px;
                    }
                    .list_item_more_icon {
                        position: absolute;
                        top: -6px;
                        right: -4px;
                        width: 12px;
                        height: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .iconfont {
                            font-size: 12px;
                        }
                        .icon-jianqu {
                            color: rgba(228, 65, 68, 1);
                        }
                        .icon-tianjia_daidise1 {
                            color: rgba(25, 144, 255, 1);
                        }
                    }
                }
                & > span {
                    margin-top: 4px;
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                }
            }
            .list_item_add {
                .list_item_icon_wrap {
                    box-sizing: border-box;
                    border-radius: 6px;
                    border: 1px dashed rgba(153, 153, 153, 1);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .iconfont {
                        font-size: 12px;
                        color: rgba(153, 153, 153, 1);
                    }
                }
            }
        }
        .menu_container {
            // overflow: hidden;
            // white-space: nowrap;
        }
        .menu_carousel_wrap {
            width: 100%;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 2px;
            span {
                width: 4px;
                height: 2px;
                background-color: rgba(25, 144, 255, 0.1);
                border-radius: 2px;
                &.active {
                    width: 6px;
                    background-color: rgba(25, 144, 255, 1);
                }
            }
        }
    }
    .card_list_wrap1 {
        .card_list_wrap_title {
            padding-bottom: 4px;
        }
        ul {
            li {
                padding-top: 8px;
            }
        }
    }
    .all_menu_wrap {
        .all_menu_list {
            height: 42px;
            opacity: 1;
            background: rgba(255, 255, 255, 1);
            display: flex;
            align-items: center;
            justify-content: space-between;
            ul {
                height: 100%;
                padding: 0 7px 0 16px;
                overflow-x: auto;
                display: flex;
                gap: 16px;
                li {
                    min-width: 64px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 42px;
                    color: rgba(102, 102, 102, 1);
                    text-align: center;
                    position: relative;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    span {
                        line-height: 22px;
                    }
                    &.active {
                        font-weight: 700;
                        color: rgba(25, 144, 255, 1);
                        &::after {
                            content: "";
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            right: 0;
                            height: 2px;
                            border-radius: 1px 1px, 0px, 0px;
                            background: rgba(41, 144, 255, 1);
                        }
                    }
                }
            }
            .all_menu_filter_icon {
                flex-shrink: 0;
                padding: 0 16px;
                img {
                    width: 16px;
                }
            }
        }
        .all_menu_container {
            margin-top: 1px;
            overflow-y: auto;
        }
        .card_list_wrap2 {
            ul {
                flex-wrap: wrap;
                padding: 0 16px;
                box-sizing: border-box;
                li {
                    margin-bottom: 16px;
                }
            }
        }
    }
}
.radio_option_wrap {
    width: 100%;
    min-height: 220px;
    max-height: 50%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    .radio_option_item {
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
        }
        .van-icon {
            color: rgba(51, 51, 51, 1);
            font-size: 12px;
        }
    }
    .radio_option_list {
        flex: 1;
        overflow-y: auto;
        .radio_option_item {
            span {
                color: rgba(102, 102, 102, 1);
            }
            .van-icon {
                color: rgba(25, 144, 255, 1);
            }
        }
    }
}
.custom_more_overlay {
    top: 44px !important;
}
</style>
